import { useState, useEffect, useContext } from 'react';
import { IUserDetailsInfo } from 'teko-oauth2';
import userHelpers from 'helpers/user';
import { userServices } from 'services';
import { IRoute } from 'interfaces';
import { StoreContext } from 'contexts';
import { IOrgChartStaff } from 'interfaces';
import { useSelector } from 'react-redux';

const useUserInfo = () => {
  const [currentUser, setCurrentUser] = useState<IUserDetailsInfo>();

  const getFullUserInfo = async () => {
    const fullUserInfo = await userServices.getFullUserInfo();
    // @ts-ignore
    setCurrentUser(fullUserInfo);
  };

  useEffect(() => {
    getFullUserInfo().then();
  }, []);

  return { currentUser };
};

const useAuthorizationData = (items: IRoute[]) => {
  const { currentUser } = useContext(StoreContext);
  const staffOrgchart: IOrgChartStaff = useSelector(
    (state: any) => state.staff
  );

  // Get navigation which match permissions to build menu
  let filteredNavigation = userHelpers.filterHasPermissions(
    items,
    currentUser.permissions
  );

  // Get navigation which match role in hr-orgchart to build menu
  filteredNavigation = userHelpers.filterRoleHR(
    filteredNavigation,
    staffOrgchart.department.roleTitle
  );

  // Get navigation which has attributes to build menu, example: VNNGTeams,Promo
  filteredNavigation = userHelpers.filterHasAttributes(
    filteredNavigation,
    currentUser.meta_data
  );

  //Get navigation which user belong to companies set in property "companies" in routes, example: VNNG=3
  const currentCompanyStr = localStorage.getItem('company_id');

  const currentCompany = currentCompanyStr
    ? parseInt(currentCompanyStr)
    : window.COMPANY_ID_VNNG;
  filteredNavigation = userHelpers.filterUserHasCompany(
    filteredNavigation,
    currentCompany
  );

  // Only get routes which is link to a component
  const filteredRoutes = filteredNavigation.filter(
    item => !item.children && item.component
  );

  return {
    filteredNavigation,
    filteredRoutes,
  };
};

const useCompanyId = () => {
  const [companyId, setCompanyId] = useState<string>('');
  const [isPartnerSP, setPartnerSP] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const getCompanyId = async () => {
    try {
      setLoading(true);
      const currCompanyId = userHelpers.getCurrentCompanyId();
      setCompanyId(currCompanyId.toString());
      setPartnerSP(currCompanyId === window.COMPANY_ID_NAB);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getCompanyId();
  }, []);

  return {
    companyId,
    isPartnerSP,
    loading,
  };
};

export default {
  useUserInfo,
  useAuthorizationData,
  useCompanyId,
};
